import { render, staticRenderFns } from "./FarmServicesNotes.vue?vue&type=template&id=12d6c6e1&"
import script from "./FarmServicesNotes.vue?vue&type=script&lang=js&"
export * from "./FarmServicesNotes.vue?vue&type=script&lang=js&"
import style0 from "./FarmServicesNotes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports